import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import firebase from 'firebase/app'
import * as serviceWorker from './serviceWorker'
import App from './App'
// This import loads the firebase namespace along with all its type information.
// Add the Firebase services that you want to use
// import 'firebase/auth';
// import 'firebase/firestore';

const firebaseConfig = {
    apiKey: 'AIzaSyAWTJykbxSXFEr3J1WPPSxms0-hnBQyrMU',
    authDomain: 'veganzone-f8b07.firebaseapp.com',
    databaseURL: 'https://veganzone-f8b07.firebaseio.com',
    projectId: 'veganzone-f8b07',
    storageBucket: 'veganzone-f8b07.appspot.com',
    messagingSenderId: '1062985061302',
    appId: '1:1062985061302:web:ba628cfd40ecea9e856717',
    measurementId: 'G-2W1P2T6LD5'
}

// const firebaseConfig = {
//     apiKey: "AIzaSyChmShI7i6Zz4tk9ZwrnWRY-OpMuDeKBMw",
//     authDomain: "veganzone-dev.firebaseapp.com",
//     projectId: "veganzone-dev",
//     storageBucket: "veganzone-dev.appspot.com",
//     messagingSenderId: "794341677154",
//     appId: "1:794341677154:web:d38e4439e1638a0601d93b",
//     measurementId: "G-7YXZEZN7FQ"
//   };

firebase.initializeApp(firebaseConfig)

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('root')
)

serviceWorker.unregister()
